//src/components/ProductList.js

import React, { useContext, useEffect, useState, useCallback } from "react";
import ProductItem from "./ProductItem";
import { itemContext } from "../context/ItemContext";

const ProductList = () => {
  const { products } = useContext(itemContext);
  const [sortedProducts, setSortedProducts] = useState([...products]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(3000);
  const [selectedType, setSelectedType] = useState("all");

  useEffect(() => {
    setSortedProducts([...products]);
  }, [products]);

  const handleSortByPrice = useCallback(() => {
    const sorted = [...sortedProducts].sort((a, b) => a.price - b.price);
    setSortedProducts(sorted);
  }, [sortedProducts]);

  const handleFilterByPriceRange = useCallback(() => {
    const filtered = products.filter(
      (product) => product.price >= minPrice && product.price <= maxPrice
    );
    setSortedProducts(filtered);
  }, [minPrice, maxPrice, products]);

  const handleFilterByType = useCallback(() => {
    if (selectedType === "all") {
      setSortedProducts([...products]);
    } else {
      const filtered = products.filter(
        (product) => product.type === selectedType
      );
      setSortedProducts(filtered);
    }
  }, [selectedType, products]);

  return (
    <div className="product-list">
      {/*<h2>Product list</h2>*/}
      <div className="filter-btn">
        <button onClick={handleSortByPrice}>Sort by Price</button>
        <label>
          Min Price:
          <input
            type="number"
            value={minPrice}
            onChange={(e) => setMinPrice(Number(e.target.value))}
          />
        </label>
        <label>
          Max Price:
          <input
            type="number"
            value={maxPrice}
            onChange={(e) => setMaxPrice(Number(e.target.value))}
          />
        </label>
        <button onClick={handleFilterByPriceRange}>
          Filter by Price Range
        </button>
        <label>
          Filter by Type:
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="all">All</option>
            <option value="Storage">Storage</option>
            <option value="Laptops">Laptop</option>
          </select>
        </label>
        <button onClick={handleFilterByType}>Filter by Type</button>
      </div>

      <ul className="item-card">
        {sortedProducts.map((product) => (
          <ProductItem key={product._id} product={product} />
        ))}
      </ul>
    </div>
  );
};

export default ProductList;
